import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type OpsOrderFragment = { __typename?: 'OpsOrder', id: string, type?: Types.MerchantOrderTypeEnum | null, system: string, container_types_used: Array<number>, status: Types.MerchantOrderStatusEnum, city: string, country: string, comment?: string | null, created_at: string, created_by_user_name?: string | null, health: Types.OpsOrderHealthEnum, carrier?: Types.OpsOrderCarrier | null, last_updated: string, delivery_date?: string | null, delivery_note_id?: number | null, total_amount: number, language?: string | null, order_execution_date?: string | null, carrier_pickup_date?: string | null, order_form_id?: string | null, store_tier?: string | null, store_type?: string | null, target_store_user_id?: string | null, discrepancy_status?: Types.ReturnOrderDiscrepancyStatus | null, store?: { __typename?: 'TextIdName', name: string, text_id?: string | null } | null, created_by?: { __typename?: 'IdName', id: string, name: string } | null, warehouse?: { __typename?: 'TextIdName', name: string, text_id?: string | null } | null, item_locations: Array<{ __typename?: 'OpsOrderItemLocation', id: string, name?: string | null }>, containers: Array<{ __typename?: 'OpsOrderSearchContainer', amount: number, order_key?: number | null, type_name: string }>, untracked_items: Array<{ __typename?: 'OpsOrderSearchUntrackedItem', amount: number, order_key?: number | null, type_name: string }>, items: Array<{ __typename?: 'OpsOrderSearchItem', amount: number, order_key?: number | null, type_name: string }>, delivery_address?: { __typename?: 'DeliveryAddressInfo', id: string, additional_info?: string | null, city?: string | null, company?: string | null, country?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, name?: string | null, phone_number?: string | null, streetname?: string | null, streetno?: string | null, zip?: string | null } | null, event?: { __typename?: 'IdName', id: string, name: string } | null, event_account?: { __typename?: 'IdName', id: string, name: string } | null, box_counts: Array<{ __typename?: 'OpsOrderBoxCount', box_size: string, count: number }> };

export const OpsOrderFragmentDoc = gql`
    fragment OpsOrder on OpsOrder {
  id
  type
  system
  container_types_used
  status
  store {
    name
    text_id
  }
  city
  country
  comment
  created_at
  created_by_user_name
  health
  carrier
  last_updated
  created_by {
    id
    name
  }
  warehouse {
    name
    text_id
  }
  item_locations {
    id
    name
  }
  containers {
    amount
    order_key
    type_name
  }
  untracked_items {
    amount
    order_key
    type_name
  }
  items {
    amount
    order_key
    type_name
  }
  delivery_date
  delivery_note_id
  delivery_address {
    id
    additional_info
    city
    company
    country
    email
    first_name
    last_name
    name
    phone_number
    streetname
    streetno
    zip
  }
  total_amount
  event {
    id
    name
  }
  event_account {
    id
    name
  }
  box_counts {
    box_size
    count
  }
  language
  order_execution_date
  carrier_pickup_date
  order_form_id
  store_tier
  store_type
  target_store_user_id
  discrepancy_status
}
    `;